// inv/src/components/ui/alertBox.jsx
import { cn } from '../../lib/utils';

export function AlertBox({
  variant = 'yellow',
  size = 'md',
  children,
  className = '',
  as: Component = 'div',
  ...props
}) {
  const variants = {
    yellow: 'bg-gradient-to-r from-neutral-100 to-orange-50 border-l-4 border-yellow-500 ',
    red:    'bg-red-100 border-l-4 border-red-500 text-red-700 ',
    blue:   'bg-blue-100 border-l-4 border-blue-500 text-blue-700 ',
    green:   'bg-green-50 border-l-4 border-stone-600 text-stone-900 ',
  };

  const sizes = {
    xs: 'py-1.5 px-4',
    md: 'p-4',
  };

  return (
    <Component
      className={cn(
        variants[variant] || variants.yellow,
        sizes[size] || sizes.md,
        'rounded-md shadow-md max-w-xl w-full',
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}

AlertBox.displayName = 'AlertBox';
